export const INIT_TEST_QUESTIONS = 'INIT_TEST_QUESTIONS';
export const ADD_USER_RESPONSE = 'ADD_USER_RESPONSE';
export const UPDATE_USER_RESPONSE = 'UPDATE_USER_RESPONSE';
export const CREATE_RESULT = 'CREATE_RESULT';
export const ADD_USER_EXTRA_RESPONSE = 'ADD_USER_EXTRA_RESPONSE';

export const initTestQuestions = questions => ({
  type: INIT_TEST_QUESTIONS,
  questions
});

export const addUserResponse = (testId, start) => ({
  type: ADD_USER_RESPONSE,
  testId,
  start
});

export const updateUserResponse = ({ testId, tag, end, theOther }) => ({
  type: UPDATE_USER_RESPONSE,
  testId,
  tag,
  end,
  theOther
});

export const createResult = result => ({
  type: CREATE_RESULT,
  result
});

export const addUserExtraResponse = response => ({
  type: ADD_USER_EXTRA_RESPONSE,
  response
});



// WEBPACK FOOTER //
// ./app/actions/index.js